/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront'
import { NewCreditClaimPhotoUploadModalComponent } from './new-credit-claim-photo-upload-modal/new-credit-claim-photo-upload-modal.component'
// import { CustomAddedToCartDialogComponent } from '../cart/add-to-cart/custom-added-to-cart-dialog/custom-added-to-cart-dialog.component';

// export const defaultAddCommentsPhotoLayoutConfig: LayoutConfig = {
//   launch: {
//     CUSTOM_COMMENTS: {
//       inlineRoot: true,
//       component: NewCreditClaimPhotoUploadModalComponent,
//       dialogType: DIALOG_TYPE.DIALOG,
//     },
//   },
// };

export const defaultAddCommentsPhotoLayoutConfig: LayoutConfig = {
  launch: {
    CUSTOM_COMMENTS: {
      inlineRoot: true,
      component: NewCreditClaimPhotoUploadModalComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
}
